export const USERS_QUERY = '/org/users';
export const USER_NOTIFICATION_PREFERENCE_QUERY = '/org/users/notifications/preferences';
export const PRIVATE_SUPPLIERS_QUERY = '/suppliers/private';
